import { render, staticRenderFns } from "./deleteInvoice.vue?vue&type=template&id=d40d875a&"
import script from "./deleteInvoice.vue?vue&type=script&lang=js&"
export * from "./deleteInvoice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports